import {Directive, ElementRef, Input, OnDestroy, OnInit,} from '@angular/core';
import {NzTableComponent} from 'ng-zorro-antd/table';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Directive({
  selector: '[nzTableHeaderStyle]',
})
export class NzTableHeaderStyleDirective implements OnInit, OnDestroy {
  @Input() tableIndex: number;
  private observer: ResizeObserver;
  private resize = new Subject<void>();

  constructor(
    private element: ElementRef,
    private nzTable: NzTableComponent<any>
  ) {
    this.observer = new ResizeObserver(() => this.resize.next());
    this.resize.pipe(debounceTime(20)).subscribe(() => this.resizeTable());
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.observer.observe(this.element.nativeElement);
    });
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
    this.resize.complete();
  }

  private resizeTable(): void {
      const tableIndex = this.tableIndex >= 0 ? this.tableIndex : 0;
      const tableHeader = document.getElementsByClassName('ant-table-header')[tableIndex];
      const tableBody = document.getElementsByClassName('ant-table-body')[tableIndex];
      if (!tableHeader || !tableBody) return;
      // Obtener el valor del límite para colocar scrollY en la tabla
      const nzTableScrollYValue = this.getNzTableScrollYValue();
      let removeScrollHeader = false;
      if (nzTableScrollYValue) {
        // Si el scrollHeight de la tabla es menor al valor límite especificado, es porque aún no llega al overflow
        // por lo tanto, ocultar el scrollY
        if (tableBody.scrollHeight < nzTableScrollYValue) {
          tableBody.classList.add('overflow-y-hidden-important');
          if (tableBody.scrollHeight > tableBody.clientHeight) {
            removeScrollHeader = true;
          }
        } else {
          tableBody.classList.remove('overflow-y-hidden-important');
        }
      } else {
        tableBody.classList.add('overflow-y-hidden-important');
        if (tableBody.scrollHeight > tableBody.clientHeight) {
          removeScrollHeader = true;
        }
      }
      if ( !removeScrollHeader && tableBody.scrollHeight > tableBody.clientHeight) {
        tableHeader.classList.remove('overflow-y-auto-important');
      } else {
        tableHeader.classList.add('overflow-y-auto-important');
      }
  }

  /**
   * Devuelve el valor especificado en el nzScrollY para que oculte el scrollY
   * cuando aún no llegue a su límite especificado
   */
  private getNzTableScrollYValue(): number {
    const nzTableScrollY = this.nzTable.nzScroll.y;
    if (!nzTableScrollY.includes('px')) return null;
    const nzScrollScrollYValue = +nzTableScrollY.substring(0, nzTableScrollY.indexOf('px'));
    if (isNaN(nzScrollScrollYValue)) return null;
    return nzScrollScrollYValue;
  }
}
